<template>

  <Form
    :title="$t('Domains')"
    :creating="creating"
    :loading="loading">
    <form
      id="domains-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveDomains(domains)">
      <ul class="form-items">
        <li
          v-for="(domain, index) in domains"
          :key="index">
          <div class="form-items-input">
            <input
              type="text"
              placeholder="name.com"
              v-model="domains[index]">
            <ValidateMessage :error="validateErrors['domains.'+index]" />
          </div>
          <div><a href="javascript:void(0)" class="text-secondary" @click="removeDomain(index)"><i class="fas fa-times" /></a></div>
        </li>
      </ul>
      <br>
      <div><a href="javascript:void(0)" @click="addDomain">{{ $t('Add domain') }}</a></div>
    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="domains-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'AccountDomains',
  components: {
    Form
  },
  data () {
    return {
      creating: true,
      loading: false,
      domains: [],
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountDomains', this.account._id)
      .then(result => {
        this.domains = result.domains
        this.creating = false
      })
    },
    addDomain () {
      this.domains.push('')
    },
    removeDomain (index) {
      this.domains.splice(index, 1)
    },
    saveDomains (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountDomains', {
        _id: this.account._id,
        domains: data
      })
      .then((result) => {
        this.domains = result.domains
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountDomains.vue